export default {
  TYPE: 'type',
  COLOR: 'color',
  THICKNESS: 'thickness',
  BORDER_RADIUS: 'border-radius',
  PADDING_VERTICAL: 'padding-vertical',
  PADDING_HORIZONTAL: 'padding-horizontal',
};
